import { render, staticRenderFns } from "./OffCanvas.vue?vue&type=template&id=1904ac04&scoped=true&"
import script from "./OffCanvas.vue?vue&type=script&lang=js&"
export * from "./OffCanvas.vue?vue&type=script&lang=js&"
import style0 from "./OffCanvas.vue?vue&type=style&index=0&id=1904ac04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1904ac04",
  null
  
)

export default component.exports